module.exports = __webpack_public_path__ + "static/media/NutriGuide_user_manual_HU_LAT.a195ab93.pdf";